import { MotoristaDetail } from '../types'
import { repository } from './motoristaRepository'

import { makeUseList } from '@elentari/core'

export const useMotoristas = makeUseList<MotoristaDetail>(repository.fetch)
